<template>
  <div>
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <a-card
          :bordered="false"
          class="header-solid h-full"
          :bodyStyle="{ padding: 0 }"
        >
          <template #title>
            <a-row type="flex" align="middle">
              <a-col :span="24" :md="12" class="top-left-header">
                <h5 class="font-semibold m-0">
                  Today Offer {{ isEditMode ? "Edit" : "Create" }}
                  <a-spin v-if="confirmLoading" />
                </h5>
              </a-col>
            </a-row>
          </template>
          <div class="new-upload-data" style="padding-left: 10px">
            <div>
              <div style="display: flex; justify-content: space-between">
                <div style="flex: 1">
                  <h4 style="font-weight: bold">
                    Category <span style="color: red">*</span>
                  </h4>
                  <a-select
                    v-model:value="todayOffer.category_id"
                    placeholder="Select a category"
                    style="width: 100%"
                    :options="categoryOptions"
                    show-search
                    :filter-option="filterOption"
                  >
                  </a-select>
                </div>

                <div style="flex: 1; margin-left: 100px">
                  <h4 style="font-weight: bold">
                    Offer Status <span style="color: red">*</span>
                  </h4>
                  <a-switch v-model:checked="todayOffer.status" />
                </div>
              </div>

              <!--              <label style="margin-right: 10px;">Offer Status</label>-->
              <!--              <a-switch v-model:checked="todayOffer.status"/>-->
              <!--            </div>-->
              <!--            <div class="d-flex flex-column">-->
              <!--              <label>Category</label>-->
              <!--              <a-select-->
              <!--                v-model:value="todayOffer.category_id"-->
              <!--                placeholder="Select a category"-->
              <!--                style="width: 100%"-->
              <!--                :options="categoryOptions"-->
              <!--              >-->
              <!--              </a-select>-->
            </div>
            <div>
              <h4 style="font-weight: bold">
                Name <span style="color: red">*</span>
              </h4>
              <a-row>
                <a-input
                  v-model="todayOffer.nameEn"
                  placeholder="Name (English)"
                />
                <a-input
                  v-model="todayOffer.nameBn"
                  placeholder="Name (Bangla)"
                  style="margin-top: 4px"
                />
              </a-row>
            </div>

            <div>
              <h4 style="font-weight: bold">
                Title <span style="color: red">*</span>
              </h4>
              <a-row>
                <a-input
                  v-model="todayOffer.titleEn"
                  placeholder="Title (English)"
                />
                <a-input
                  v-model="todayOffer.titleBn"
                  placeholder="Title (Bangla)"
                  style="margin-top: 4px"
                />
              </a-row>
            </div>

            <div>
              <h4 style="font-weight: bold">
                Offer Title <span style="color: red">*</span>
              </h4>
              <a-row>
                <a-input
                  v-model="todayOffer.offerTitleEn"
                  placeholder="Offer Title (English)"
                />
                <a-input
                  v-model="todayOffer.offerTitleBn"
                  placeholder="Offer Title (Bangla)"
                  style="margin-top: 4px"
                />
              </a-row>
            </div>

            <div>
              <h4 style="font-weight: bold">
                Offer Details <span style="color: red">*</span>
              </h4>
              <a-row>
                <a-input
                  v-model="todayOffer.offerDetailsEn"
                  placeholder="Offer Details (English)"
                />
                <a-input
                  v-model="todayOffer.offerDetailsBn"
                  placeholder="Offer Details (Bangla)"
                  style="margin-top: 4px"
                />
              </a-row>
            </div>

            <div>
              <h4 style="font-weight: bold">
                Offer Description Title <span style="color: red">*</span>
              </h4>
              <a-row>
                <a-input
                  v-model="todayOffer.descriptionTitleEn"
                  placeholder="Description Title (English)"
                />
                <a-input
                  v-model="todayOffer.descriptionTitleBn"
                  placeholder="Description Title (Bangla)"
                  style="margin-top: 4px"
                />
              </a-row>
            </div>
            <div>
              <h4 style="font-weight: bold">
                Offer Description Details <span style="color: red">*</span>
              </h4>
              <a-row>
                <a-input
                  v-model="todayOffer.descriptionDetailsEn"
                  placeholder="Description Details (English)"
                />
                <a-input
                  v-model="todayOffer.descriptionDetailsBn"
                  placeholder="Description Details (Bangla)"
                  style="margin-top: 4px"
                />
              </a-row>
            </div>

            <div>
              <h4 style="font-weight: bold">
                Terms & Condition <span style="color: red">*</span>
              </h4>

              <a-row>
                <a-input
                  v-model="todayOffer.termsAndConditionsEn"
                  placeholder="Terms and Condition (English)"
                />
                <a-input
                  v-model="todayOffer.termsAndConditionsBn"
                  placeholder="Terms and Condition (Bangla)"
                  style="margin-top: 4px"
                />
              </a-row>
            </div>
            <div>
              <h4>Offer Type <span style="color: red">*</span></h4>
              <a-select
                v-model:value="todayOffer.offerType"
                placeholder="Select a offer type"
                style="width: 50%"
                :options="offerTypeOptions"
                @change="onOfferTypeChange"
              ></a-select>
            </div>

            <div>
              <h4>Offer Validity <span style="color: red">*</span></h4>
              <div style="display: flex">
                <div style="margin-right: 20px">
                  <div>Start Date</div>
                  <a-date-picker
                    style="width: 50%"
                    v-model="todayOffer.startDate"
                    placeholder="Start Date"
                    show-time
                    format="YYYY-MM-DD HH:mm:ss"
                    @change="onStartDateChange"
                  />
                </div>
                <div>
                  <div>End Date</div>
                  <a-date-picker
                    style="width: 50%"
                    v-model="todayOffer.endDate"
                    placeholder="End Date"
                    show-time
                    format="YYYY-MM-DD HH:mm"
                    @change="onEndDateChange"
                  />
                </div>
              </div>
            </div>

            <div v-if="showWeekday">
              <h4>Week Day <span style="color: red">*</span></h4>
              <a-select
                v-model:value="todayOffer.weekDay"
                placeholder="Select a week day"
                style="width: 50%"
                :options="weekDayOptions"
              ></a-select>
            </div>
            <div style="display: flex">
              <div style="flex: 1">
                <h6 style="margin-right: 16px">Weight</h6>
                <a-input-number
                  style="width: 50%"
                  v-model="todayOffer.weight"
                  placeholder="Weight"
                />
              </div>
              <div style="flex: 1">
                <h6 style="margin-right: 16px">Discount Amount</h6>
                <a-input-number
                  style="width: 50%"
                  v-model="todayOffer.discountAmount"
                  placeholder="Discount Amount"
                />
                <a-select
                  v-model:value="todayOffer.discountType"
                  placeholder="Select a discount Type"
                  :options="[
                    { value: 'percentage', label: 'Percentage' },
                    { value: 'fixed', label: 'Fixed' },
                  ]"
                  @change="changeDiscountType"
                  style="margin-left: 5px"
                >
                </a-select>
              </div>
            </div>

            <div v-if="this.isEditMode" class="mt-5">
              <img
                :src="todayOffer.logo"
                :alt="todayOffer.nameEn"
                height="100"
                width="100"
              />
            </div>
            <div>
              <h4>Logo <span style="color: red">*</span></h4>
              <a-input
                type="file"
                @change="onLogoFileChange"
                placeholder="Basic usage"
                accept="image/png, image/jpeg, image/jpg"
              />
              <small><i>Dimension should be 96 x 96</i></small>
            </div>
            <div>
              <h4>Cover Images <span style="color: red">*</span></h4>
              <div class="new-upload-data" style="margin: 0 16px">
                <div v-for="(item, index) in this.todayOffer.coverImages">
                  <div v-if="isEditMode && item.icon.length > 0" class="mt-5">
                    <img
                      :src="item.icon"
                      :alt="`Cover image ${index + 1}`"
                      height="100"
                      width="100"
                    />
                  </div>
                  <label>Cover Image {{ index + 1 }}</label>
                  <a-row type="flex" justify="space-between">
                    <div style="width: 50%">
                      <a-input
                        type="file"
                        @change="onCoverImageFileChange($event, index)"
                        placeholder="Basic usage"
                        accept="image/png, image/jpeg, image/jpg"
                      />
                      <small
                        ><i>Minimum image dimension is 1080 x 1080</i></small
                      >
                    </div>
                    <a-row v-if="todayOffer.coverImages.length > 1" type="flex">
                      <a-col :span="2">
                        <a-button type="danger" @click="removeCoverImage(index)"
                          >Remove</a-button
                        >
                      </a-col>
                    </a-row>
                  </a-row>
                </div>
                <a-row type="flex" justify="start">
                  <a-col :span="2">
                    <a-button type="primary" @click="addCoverImage"
                      >Add Cover Image</a-button
                    >
                  </a-col>
                </a-row>
              </div>
            </div>
            <div v-if="errorMsg.length" class="ant-btn-danger mt-5">
              {{ errorMsg }}
            </div>
            <div class="mt-5 left-align-content">
              <a-button
                type="primary"
                @click="onSubmit"
                :loading="confirmLoading"
                >Submit</a-button
              >
            </div>
          </div>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { sendRequest } from "@/http/axios.method";
import { message } from "ant-design-vue";
import { VueEditor } from "vue2-editor";

export default {
  name: "today-offer-form",
  components: {
    VueEditor,
  },
  data() {
    return {
      config: {
        Authorization: "Bearer " + this.$store.state.authUser?.token,
      },
      categoryOptions: [],
      confirmLoading: false,
      todayOffer: {
        id: "",
        category_id: "",
        nameEn: "",
        nameBn: "",
        titleEn: "",
        titleBn: "",
        offerTitleEn: "",
        offerTitleBn: "",
        offerDetailsEn: "",
        offerDetailsBn: "",
        descriptionTitleEn: "",
        descriptionTitleBn: "",
        descriptionDetailsEn: "",
        descriptionDetailsBn: "",
        termsAndConditionsEn: "",
        termsAndConditionsBn: "",
        startDate: "",
        endDate: "",
        offerType: "",
        weekDay: "",
        weight: "",
        discountAmount: "",
        discountType: "percentage",
        logo: "",
        updatedLogo: "",
        coverImages: [
          {
            icon: "",
          },
        ],
        updatedCoverImages: [],
        status: true,
      },
      logoContent: "",
      offerTypeOptions: [
        { value: "daily", label: "Daily" },
        { value: "weekly", label: "Weekly" },
      ],
      weekDayOptions: [
        { value: 1, label: "Sunday" },
        { value: 2, label: "Monday" },
        { value: 3, label: "Tuesday" },
        { value: 4, label: "Wednesday" },
        { value: 5, label: "Thursday" },
        { value: 6, label: "Friday" },
        { value: 7, label: "Saturday" },
      ],
      errorMsg: "",
      isEditMode: false,
      showWeekday: false,
    };
  },
  created() {
    this.isEditMode = this.$route.params.id !== undefined;
    if (this.isEditMode) {
      const todayOfferId = this.$route.params.id;
      this.fetchTodayOfferById(todayOfferId);
    }
    this.getCategoryList();
  },
  methods: {
    removeCoverImage(index) {
      if (this.todayOffer.coverImages.length > 1) {
        this.todayOffer.coverImages.splice(index, 1);
      }
    },
    addCoverImage() {
      this.todayOffer.coverImages.push({
        icon: "",
      });
    },
    onOfferTypeChange(value) {
      if (value === "weekly") {
        this.showWeekday = true;
      } else {
        this.showWeekday = false;
        this.todayOffer.weekDay = 0;
      }
    },
    getCategoryList() {
      this.confirmLoading = true;
      sendRequest("get", "admin/categories/active", {}, this.config)
        .then((response) => {
          this.confirmLoading = false;
          if (response.success) {
            let categoryList = response.data;
            this.categoryOptions = categoryList.map(function (category, label) {
              return {
                value: category.id,
                label: category.name,
              };
            });
          } else {
            if (response.status_code === 401) {
              this.$store.dispatch("logout");
              this.$router.push("/login");
            }
          }
        })
        .catch(() => {
          this.confirmLoading = false;
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    fetchTodayOfferById(todayOfferId) {
      this.confirmLoading = true;
      sendRequest("get", "admin/today-offers/" + todayOfferId, {}, this.config)
        .then((response) => {
          this.confirmLoading = false;
          if (response.success) {
            let todayOfferData = response.data;
            this.todayOffer.id = todayOfferData.id;
            this.todayOffer.category_id = todayOfferData.category_id;
            this.todayOffer.nameEn = todayOfferData.name.en;
            this.todayOffer.nameBn = todayOfferData.name.bn;
            this.todayOffer.titleEn = todayOfferData.title.en;
            this.todayOffer.titleBn = todayOfferData.title.bn;
            this.todayOffer.offerTitleEn = todayOfferData.offer_title.en;
            this.todayOffer.offerTitleBn = todayOfferData.offer_title.bn;
            this.todayOffer.offerDetailsEn = todayOfferData.offer_details.en;
            this.todayOffer.offerDetailsBn = todayOfferData.offer_details.bn;
            this.todayOffer.descriptionTitleEn =
              todayOfferData.description.en.title;
            this.todayOffer.descriptionTitleBn =
              todayOfferData.description.bn.title;
            this.todayOffer.descriptionDetailsEn =
              todayOfferData.description.en.details;
            this.todayOffer.descriptionDetailsBn =
              todayOfferData.description.bn.details;
            this.todayOffer.termsAndConditionsEn =
              todayOfferData.term_and_condition.en;
            this.todayOffer.termsAndConditionsBn =
              todayOfferData.term_and_condition.bn;
            this.todayOffer.startDate = todayOfferData.start_date;
            this.todayOffer.endDate = todayOfferData.end_date;
            this.todayOffer.offerType = todayOfferData.today_offer_type;
            this.todayOffer.weight = todayOfferData.weight;
            this.todayOffer.status = !!todayOfferData.status;
            this.todayOffer.logo = todayOfferData.logo;
            this.todayOffer.discountAmount =
              todayOfferData.discount_amount || 0;
            this.todayOffer.discountType =
              todayOfferData.discount_type || "percentage";
            if (this.todayOffer.offerType === "weekly") {
              this.showWeekday = true;
              this.todayOffer.weekDay = this.getWeekDay(
                todayOfferData.week_day
              );
            } else {
              this.todayOffer.weekDay = "";
            }
            todayOfferData.coverImages.data.forEach((image) => {
              this.todayOffer.coverImages.push({
                icon: image.image,
              });
            });
          } else {
            if (response.status_code === 401) {
              this.$store.dispatch("logout");
              this.$router.push("/login");
            }
          }
        })
        .catch(() => {
          this.confirmLoading = false;
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    getWeekDay(weekDay) {
      const weekDayOptions = {
        Sunday: 1,
        Monday: 2,
        Tuesday: 3,
        Wednesday: 4,
        Thursday: 5,
        Friday: 6,
        Saturday: 7,
      };
      return weekDayOptions[weekDay];
    },
    onCoverImageFileChange(e, index) {
      this.errorMsg = "";
      if (this.isEditMode) {
        this.todayOffer.updatedCoverImages[index] = e.target.files[0];
      } else {
        this.todayOffer.coverImages[index].icon = e.target.files[0];
      }
    },
    onLogoFileChange(e) {
      this.errorMsg = "";
      if (this.isEditMode) {
        this.todayOffer.updatedLogo = e.target.files[0];
      } else {
        this.todayOffer.logo = e.target.files[0];
      }
    },
    onStartDateChange(value, dateString) {
      this.todayOffer.startDate = value.format("YYYY-MM-DD HH:mm");
    },
    onEndDateChange(value, dateString) {
      this.todayOffer.endDate = value.format("YYYY-MM-DD HH:mm");
    },

    onSubmit() {
      if (this.isEditMode) {
        this.updateTodayOffer();
      } else {
        this.createTodayOffer();
      }
    },

    createTodayOffer() {
      this.confirmLoading = true;
      this.errorMsg = "";
      if (this.todayOffer.category_id.length === 0) {
        this.confirmLoading = false;
        message.error({
          style: {
            marginTop: "20vh",
          },
          class: "custom-class",
          content: () => "Please provide category",
        });
        return;
      }
      if (this.todayOffer.nameEn.length === 0) {
        this.confirmLoading = false;
        message.error({
          style: {
            marginTop: "20vh",
          },
          class: "custom-class",
          content: () => "Please provide name in English",
        });
        return;
      }
      if (this.todayOffer.nameBn.length === 0) {
        this.confirmLoading = false;
        message.error({
          style: {
            marginTop: "20vh",
          },
          class: "custom-class",
          content: () => "Please provide name in Bangla",
        });
        return;
      }
      if (this.todayOffer.titleEn.length === 0) {
        this.confirmLoading = false;
        message.error({
          style: {
            marginTop: "20vh",
          },
          class: "custom-class",
          content: () => "Please provide title in English",
        });
        return;
      }
      if (this.todayOffer.titleBn.length === 0) {
        this.confirmLoading = false;
        message.error({
          style: {
            marginTop: "20vh",
          },
          class: "custom-class",
          content: () => "Please provide title in Bangla",
        });
        return;
      }
      if (this.todayOffer.offerTitleEn.length === 0) {
        this.confirmLoading = false;
        message.error({
          style: {
            marginTop: "20vh",
          },
          class: "custom-class",
          content: () => "Please provide offer title in English",
        });
        return;
      }
      if (this.todayOffer.offerTitleBn.length === 0) {
        this.confirmLoading = false;
        message.error({
          style: {
            marginTop: "20vh",
          },
          class: "custom-class",
          content: () => "Please provide offer title in Bangla",
        });
        return;
      }
      if (this.todayOffer.offerDetailsEn.length === 0) {
        this.confirmLoading = false;
        message.error({
          style: {
            marginTop: "20vh",
          },
          class: "custom-class",
          content: () => "Please provide offer details in English",
        });
        return;
      }
      if (this.todayOffer.offerDetailsBn.length === 0) {
        this.confirmLoading = false;
        message.error({
          style: {
            marginTop: "20vh",
          },
          class: "custom-class",
          content: () => "Please provide offer details in Bangla",
        });
        return;
      }
      if (this.todayOffer.descriptionTitleEn.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide description title in English",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }
      if (this.todayOffer.descriptionTitleBn.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide description title in Bangla",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }
      if (this.todayOffer.descriptionDetailsEn.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide description details in English",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }
      if (this.todayOffer.descriptionDetailsBn.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide description details in Bangla",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }
      if (this.todayOffer.termsAndConditionsEn.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide term and condition in English",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }
      if (this.todayOffer.termsAndConditionsBn.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide term and condition in Bangla",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }
      if (this.todayOffer.startDate.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide start date",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }
      if (this.todayOffer.endDate.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide end date",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }
      if (this.todayOffer.offerType.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide offer type.",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }
      if (this.todayOffer.offerType === "weekly") {
        if (this.todayOffer.weekDay === 0) {
          this.confirmLoading = false;
          message.error({
            content: () => "Please provide week day.",
            class: "custom-class",
            style: {
              marginTop: "20vh",
            },
          });
          return;
        }
      }
      if (this.todayOffer.logo.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide logo.",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }

      let formData = new FormData();
      let configHeader = {
        "content-type": "multipart/form-data",
        Authorization: "Bearer " + this.$store.state.authUser?.token,
      };
      formData.append("category_id", this.todayOffer.category_id);
      formData.append("name[en]", this.todayOffer.nameEn);
      formData.append("name[bn]", this.todayOffer.nameBn);
      formData.append("title[en]", this.todayOffer.titleEn);
      formData.append("title[bn]", this.todayOffer.titleBn);
      formData.append("offer_title[en]", this.todayOffer.offerTitleEn);
      formData.append("offer_title[bn]", this.todayOffer.offerTitleBn);
      formData.append("offer_details[en]", this.todayOffer.offerDetailsEn);
      formData.append("offer_details[bn]", this.todayOffer.offerDetailsBn);
      formData.append(
        "description[en][title]",
        this.todayOffer.descriptionTitleEn
      );
      formData.append(
        "description[bn][title]",
        this.todayOffer.descriptionTitleBn
      );
      formData.append(
        "description[en][details]",
        this.todayOffer.descriptionDetailsEn
      );
      formData.append(
        "description[bn][details]",
        this.todayOffer.descriptionDetailsBn
      );
      formData.append(
        "term_and_condition[en]",
        this.todayOffer.termsAndConditionsEn
      );
      formData.append(
        "term_and_condition[bn]",
        this.todayOffer.termsAndConditionsBn
      );
      formData.append("weight", Number(this.todayOffer.weight));
      formData.append(
        "discount_amount",
        Number(this.todayOffer.discountAmount)
      );
      formData.append("discount_type", this.todayOffer.discountType);
      formData.append("start_date", this.todayOffer.startDate);
      formData.append("end_date", this.todayOffer.endDate);
      formData.append("today_offer_type", this.todayOffer.offerType);
      formData.append("week_day", Number(this.todayOffer.weekDay));
      formData.append("status", Number(this.todayOffer.status));
      formData.append("logo", this.todayOffer.logo);
      this.todayOffer.coverImages.forEach((image) => {
        formData.append("coverImages[]", image.icon);
      });

      sendRequest("post", "admin/special-offers", formData, configHeader)
        .then((response) => {
          if (response.success) {
            message.success({
              content: () => "Successfully Added",
              class: "custom-class",
              style: {
                marginTop: "20vh",
              },
            });
            this.confirmLoading = false;
            this.$router.push("/today-offers");
          } else {
            message.error({
              content: () => response.message,
              class: "custom-class",
              style: {
                marginTop: "20vh",
              },
            });
          }
        })
        .catch(() => {
          this.confirmLoading = false;
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },

    updateTodayOffer() {
      this.confirmLoading = true;
      this.errorMsg = "";
      if (this.todayOffer.category_id.length === 0) {
        this.confirmLoading = false;
        message.error({
          style: {
            marginTop: "20vh",
          },
          class: "custom-class",
          content: () => "Please provide category",
        });
        return;
      }
      if (this.todayOffer.nameEn.length === 0) {
        this.confirmLoading = false;
        message.error({
          style: {
            marginTop: "20vh",
          },
          class: "custom-class",
          content: () => "Please provide name in English",
        });
        return;
      }
      if (this.todayOffer.nameBn.length === 0) {
        this.confirmLoading = false;
        message.error({
          style: {
            marginTop: "20vh",
          },
          class: "custom-class",
          content: () => "Please provide name in Bangla",
        });
        return;
      }
      if (this.todayOffer.titleEn.length === 0) {
        this.confirmLoading = false;
        message.error({
          style: {
            marginTop: "20vh",
          },
          class: "custom-class",
          content: () => "Please provide title in English",
        });
        return;
      }
      if (this.todayOffer.titleBn.length === 0) {
        this.confirmLoading = false;
        message.error({
          style: {
            marginTop: "20vh",
          },
          class: "custom-class",
          content: () => "Please provide title in Bangla",
        });
        return;
      }
      if (this.todayOffer.offerTitleEn.length === 0) {
        this.confirmLoading = false;
        message.error({
          style: {
            marginTop: "20vh",
          },
          class: "custom-class",
          content: () => "Please provide offer title in English",
        });
        return;
      }
      if (this.todayOffer.offerTitleBn.length === 0) {
        this.confirmLoading = false;
        message.error({
          style: {
            marginTop: "20vh",
          },
          class: "custom-class",
          content: () => "Please provide offer title in Bangla",
        });
        return;
      }
      if (this.todayOffer.offerDetailsEn.length === 0) {
        this.confirmLoading = false;
        message.error({
          style: {
            marginTop: "20vh",
          },
          class: "custom-class",
          content: () => "Please provide offer details in English",
        });
        return;
      }
      if (this.todayOffer.offerDetailsBn.length === 0) {
        this.confirmLoading = false;
        message.error({
          style: {
            marginTop: "20vh",
          },
          class: "custom-class",
          content: () => "Please provide offer details in Bangla",
        });
        return;
      }
      if (this.todayOffer.descriptionTitleEn.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide description title in English",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }
      if (this.todayOffer.descriptionTitleBn.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide description title in Bangla",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }
      if (this.todayOffer.descriptionDetailsEn.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide description details in English",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }
      if (this.todayOffer.descriptionDetailsBn.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide description details in Bangla",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }
      if (this.todayOffer.termsAndConditionsEn.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide term and condition in English",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }
      if (this.todayOffer.termsAndConditionsBn.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide term and condition in Bangla",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }
      if (this.todayOffer.startDate.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide start date",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }
      if (this.todayOffer.endDate.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide end date",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }
      if (this.todayOffer.offerType.length === 0) {
        this.confirmLoading = false;
        message.error({
          content: () => "Please provide offer type.",
          class: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        return;
      }
      if (this.todayOffer.offerType === "weekly") {
        if (this.todayOffer.weekDay === 0) {
          this.confirmLoading = false;
          message.error({
            content: () => "Please provide week day.",
            class: "custom-class",
            style: {
              marginTop: "20vh",
            },
          });
          return;
        }
      }

      let formData = new FormData();
      let configHeader = {
        "content-type": "multipart/form-data",
        Authorization: "Bearer " + this.$store.state.authUser?.token,
      };
      formData.append("category_id", this.todayOffer.category_id);
      formData.append("name[en]", this.todayOffer.nameEn);
      formData.append("name[bn]", this.todayOffer.nameBn);
      formData.append("title[en]", this.todayOffer.titleEn);
      formData.append("title[bn]", this.todayOffer.titleBn);
      formData.append("offer_title[en]", this.todayOffer.offerTitleEn);
      formData.append("offer_title[bn]", this.todayOffer.offerTitleBn);
      formData.append("offer_details[en]", this.todayOffer.offerDetailsEn);
      formData.append("offer_details[bn]", this.todayOffer.offerDetailsBn);
      formData.append(
        "description[en][title]",
        this.todayOffer.descriptionTitleEn
      );
      formData.append(
        "description[bn][title]",
        this.todayOffer.descriptionTitleBn
      );
      formData.append(
        "description[en][details]",
        this.todayOffer.descriptionDetailsEn
      );
      formData.append(
        "description[bn][details]",
        this.todayOffer.descriptionDetailsBn
      );
      formData.append(
        "term_and_condition[en]",
        this.todayOffer.termsAndConditionsEn
      );
      formData.append(
        "term_and_condition[bn]",
        this.todayOffer.termsAndConditionsBn
      );
      formData.append("weight", Number(this.todayOffer.weight));
      formData.append(
        "discount_amount",
        Number(this.todayOffer.discountAmount)
      );
      formData.append("discount_type", this.todayOffer.discountType);
      formData.append("start_date", this.todayOffer.startDate);
      formData.append("end_date", this.todayOffer.endDate);
      formData.append("today_offer_type", this.todayOffer.offerType);
      formData.append("week_day", Number(this.todayOffer.weekDay));
      formData.append("status", Number(this.todayOffer.status));
      formData.append("logo", this.todayOffer.logo);
      if (this.todayOffer.updatedLogo) {
        formData.append("logo", this.todayOffer.updatedLogo);
      } else {
        formData.append("logo", this.todayOffer.logo);
      }
      this.todayOffer.coverImages.forEach((image, index) => {
        if (
          this.todayOffer.updatedCoverImages.length > 0 &&
          this.todayOffer.updatedCoverImages[index] !== undefined
        ) {
          formData.append(
            `coverImages[${index}]`,
            this.todayOffer.updatedCoverImages[index]
          );
        } else {
          formData.append(`coverImages[${index}]`, image.icon);
        }
      });

      sendRequest(
        "post",
        `admin/special-offers/${this.todayOffer.id}`,
        formData,
        configHeader
      )
        .then((response) => {
          if (response.success) {
            message.success({
              content: () => "Successfully Updated",
              class: "custom-class",
              style: {
                marginTop: "20vh",
              },
            });
            this.confirmLoading = false;
            this.$router.push("/today-offers");
          } else {
            message.error({
              content: () => response.message,
              class: "custom-class",
              style: {
                marginTop: "20vh",
              },
            });
          }
        })
        .catch(() => {
          this.confirmLoading = false;
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
  },
  filterOption(input, option) {
    return (
      option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    );
  },
};
</script>
